import { createContext } from "react";
import { GlobalUserPreferences } from "@jugl-web/rest-api/users/models/common-types/GlobalUserPreferences";
import { GetStartedDialogStep } from "../types";

export type OnboardingStatusSteps = Omit<
  GlobalUserPreferences,
  "welcome" | "onBoardingFinish"
>;

export const OnboardingContext = createContext<{
  onboardingStatus?: OnboardingStatusSteps;
  isOnboardingFinished: boolean;
  isOnboardingActive: boolean;
  openedSpotlight?: GetStartedDialogStep;
  openSpotlight: (type?: GetStartedDialogStep) => void;
  openDialog: () => void;
  completeOnboardingStep: (type: GetStartedDialogStep) => void;
} | null>(null);
